import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-end gap-x-2" }

import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();

function goToCreate() {
  router.push({ name: 'ScorecardEditor' });
}
function goToArchive() {
  router.push({ name: 'Archive' });
}

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Button, {
      label: "+",
      onClick: goToCreate
    }),
    _createVNode(_component_Button, {
      label: "View Archive",
      onClick: goToArchive
    })
  ]))
}
}

})